import { Measurements } from '~/utility/BinSentry-ui-utility';
import { BnAction } from '../../common/bn-action';

class BinUpdateDetails extends BnAction {
  constructor() {
    super();
    this.actionname = 'update-details';
    this.successtext = 'Bin details have been updated.';
    this.errortext = 'Failed to update bin details.';
    this.submittext = 'Update';
  }

  preRender(action) {
    const measurement = Measurements.get('weight');
    action.fields.forEach((field) => {
      if (field.name === 'listedCapacity') {
        if (!Object.keys(field).includes('originalValue')) {
          field.originalValue = field.value;
        }
        field.value = measurement.convert({ weight: field.originalValue }) || '';
        field.suffix = measurement.unit;
      }
    });
  }

  preSubmit(fields) {
    const measurement = Measurements.get('weight');
    for (const [key, val] of fields.entries()) {
      if (key === 'listedCapacity') {
        fields.set(key, val === '' ? '' : measurement.reverse({ weight: val }));
      }
    }
  }
}

window.customElements.define('bin-update-details', BinUpdateDetails);
